




















































































































































import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import { listReq } from "@/common/class/h5/index";
import { getPublishedItinerary } from "@/api/scheduleManagement/index";
import topItem from "@/components/common/header/index.vue";
import { Cell } from "vant";
import { Pagination, Loading } from "vant";

@Component({
  components: {
    [Cell.name]: Cell,
    [Pagination.name]: Pagination,
    [Loading.name]: Loading,
    topItem,
  },
})
export default class empowermentQueryComponent extends Vue {
  loading = false;
  finished = false;
  list = new DataParse();
  req = new listReq();
  showDetail = false;
  detailContent = "";
  componentName = topItem;
  created() {
    this.getList();
  }

  mounted() {}

  getList() {
    this.loading = true;
    getPublishedItinerary(this.req)
      .then((res) => {
        const { data, message, success } = res;
        if (success) {
          this.list.listItem = data.rows;
          this.list.total = data.total;
        }
      })
      .finally(() => {
        this.loading = false;
        this.finished = true;
      });
  }
  getDetail(id: any) {
    this.$router.push({ path: "itineraryDetail", query: { id: id } });
  }
  goBack() {
    this.$router.push("home");
  }
}
